"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DlgLogout = /** @class */ (function (_super) {
    __extends(DlgLogout, _super);
    function DlgLogout(props) {
        return _super.call(this, props) || this;
    }
    DlgLogout.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({ visible: data.visible });
        });
        this.setState({ visible: this.props.controller.DATA.visible });
    };
    DlgLogout.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgLogout.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgLogout.prototype.handleYes = function () {
        this.props.controller.Close();
        if (this.props.controller.OnYes) {
            this.props.controller.OnYes();
        }
    };
    DlgLogout.prototype.render = function () {
        return (React.createElement(antd_1.Modal, { title: "\u0412\u042B\u0425\u041E\u0414", visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: false, maskClosable: false, okType: "danger" },
            React.createElement("p", null, "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u043F\u0430\u043D\u0435\u043B\u0438 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F ?")));
    };
    return DlgLogout;
}(React.Component));
exports.default = DlgLogout;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgLogout.tsx
// module id = 1717
// module chunks = 0